require('www/js/libs/magnific-popup/jquery.magnific-popup.min')
